/**
 * Policy (real `/v2/policy/` backend). MVP is a single Policy Number per
 * submission (Andressa: created as its own page now so it can grow later
 * without migrating data). One policy per submission.
 *
 *   GET    /v2/policy/?submission_id=…   list (filter)
 *   POST   /v2/policy/                   create { submission_id, policy_number }
 *   PATCH  /v2/policy/{id}               update { policy_number }
 */
import { getJsonReal, sendJsonReal } from "../client";

export interface PolicyWire {
    id: string;
    submission_id: string;
    policy_number: string | null;
    created_at: string;
    updated_at: string;
}

/** The submission's policy, or null when none exists yet. */
export async function getPolicyForSubmission(submissionId: string): Promise<PolicyWire | null> {
    const rows = await getJsonReal<PolicyWire[]>(`/v2/policy/?submission_id=${encodeURIComponent(submissionId)}`);
    return rows[0] ?? null;
}

export function createPolicy(submissionId: string, policyNumber: string): Promise<PolicyWire> {
    return sendJsonReal<PolicyWire>("/v2/policy/", "POST", { submission_id: submissionId, policy_number: policyNumber });
}

export function updatePolicy(policyId: string, policyNumber: string): Promise<PolicyWire> {
    return sendJsonReal<PolicyWire>(`/v2/policy/${encodeURIComponent(policyId)}`, "PATCH", { policy_number: policyNumber });
}
